<nav
  *ngIf="connectedUser"
  class="fixed-left bg-white sidenav navbar navbar-vertical navbar-expand-xs navbar-light"
  id="sidenav-main"
>
  <div class="scroll-wrapper scrollbar-inner">
    <div
      class="scroll-content scroll-scrolly_visible scrollbar-inner"
      style="
        height: auto;
        margin-bottom: 0px;
        margin-right: 0px;
        max-height: 738.4px;
      "
    >
      <div class="text-center sidenav-header">
        <a class="navbar-brand">
          <span class="text-primary site-title">
            <span class="main-font-en text-lowercase">Kharaaj</span> خراج</span
          >
        </a>
      </div>

      <div class="navbar-inner">
        <hr />
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <ul class="navbar-nav">
            <li (click)="hideMenu()" class="nav-item">
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'الصفحة الرئيسية تحتوي على نظرة عامة على نشاطك وإحصائيات مهمة'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active: currentSection === ROUTES.PRIVATE.DASHBOARD.HOME
                }"
                (click)="changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.HOME)"
                role="button"
              >
                <span class="nav-link-text">الرئيسية</span>
                <i class="text-primary ni ni-shop"></i>
              </a>
            </li>
            
            <li
              *ngIf="
                type === USER_TYPES.BUYER_SELLER ||
                type === USER_TYPES.BUYER ||
                type === USER_TYPES.SELLER ||
                type === USER_TYPES.TRANSPORTER_COMPANY ||
                type === USER_TYPES.TRANSPORTER_AGENT ||
                type === USER_TYPES.MARKETER
              "
              class="nav-item"
            >
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'إدارة معلومات حسابك الشخصي والإعدادات والمفضلات'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active: currentSection === ROUTES.PRIVATE.DASHBOARD.MY_ACCOUNT
                }"
                (click)="
                  changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.MY_ACCOUNT)
                "
                role="button"
              >
                <span class="nav-link-text">حسابي</span>
                <i class="text-primary ni ni-single-02"></i>
              </a>
              
              <ul
                class="s-level"
                *ngIf="currentSection === ROUTES.PRIVATE.DASHBOARD.MY_ACCOUNT"
              >
                <li (click)="hideMenu()" class="s-nav-item">
                  <a
                    class="s-nav-link"
                    nz-tooltip
                    [nzTooltipTitle]="'إدارة رصيدك المالي، إيداع الأموال، وسحب الأرباح'"
                    nzTooltipPlacement="bottom"
                    [ngClass]="{
                      active:
                        currentSubSection ===
                        ROUTES.PRIVATE.DASHBOARD.MY_ACCOUNT
                    }"
                    (click)="
                      changeCurrentSubSection(
                        ROUTES.PRIVATE.DASHBOARD.MY_ACCOUNT_CHILDS.WALLET
                      )
                    "
                    role="button"
                  >
                    <span class="nav-link-text">محفظتي</span>
                    <i class="text-primary ni ni-credit-card"></i>
                  </a>
                </li>
              </ul>
            </li>
            
            <li
              *ngIf="
                type === USER_TYPES.BUYER_SELLER ||
                type === USER_TYPES.BUYER ||
                type === USER_TYPES.SELLER ||
                type === USER_TYPES.TRANSPORTER_AGENT ||
                type === USER_TYPES.TRANSPORTER_COMPANY
              "
              class="nav-item"
            >
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'إدارة خدمات النقل، طلبات التوصيل، ومتابعة الشحنات'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active: currentSection === ROUTES.PRIVATE.DASHBOARD.TRANSPORT
                }"
                (click)="
                  changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.TRANSPORT)
                "
                role="button"
              >
                <span class="nav-link-text">قسم النقل</span>
                <i class="text-primary ni ni-delivery-fast"></i>
              </a>
              
              <ul
                class="s-level"
                *ngIf="currentSection === ROUTES.PRIVATE.DASHBOARD.TRANSPORT"
              >
                <li (click)="hideMenu()" class="s-nav-item">
                  <a
                    class="s-nav-link"
                    nz-tooltip
                    [nzTooltipTitle]="'عرض وعمل عروض أسعار لطلبات النقل الجديدة'"
                    nzTooltipPlacement="bottom"
                    [ngClass]="{
                      active:
                        currentSubSection ===
                        ROUTES.PRIVATE.DASHBOARD.TRANSPORT_CHILDS.REQUESTS
                    }"
                    (click)="
                      changeCurrentSubSection(
                        ROUTES.PRIVATE.DASHBOARD.TRANSPORT_CHILDS.REQUESTS
                      )
                    "
                    role="button"
                  >
                    <span class="nav-link-text">طلبات السعر</span>
                    <i class="text-primary ni ni-money-coins"></i>
                  </a>
                </li>
                
                <hr>
                <li (click)="hideMenu()" class="s-nav-item">
                  <a
                    class="s-nav-link"
                    nz-tooltip
                    [nzTooltipTitle]="'سجل جميع عمليات التوصيل التي قمت بها أو استلمتها'"
                    nzTooltipPlacement="bottom"
                    [ngClass]="{
                      active:
                        currentSubSection ===
                        ROUTES.PRIVATE.DASHBOARD.TRANSPORT_CHILDS.HISTORY
                    }"
                    (click)="
                      changeCurrentSubSection(
                        ROUTES.PRIVATE.DASHBOARD.TRANSPORT_CHILDS.HISTORY
                      )
                    "
                    role="button"
                  >
                    <span class="nav-link-text">توصيلاتى</span>
                    <i class="text-primary ni ni-time"></i>
                  </a>
                </li>
                
                <hr>
                <li (click)="hideMenu()" class="s-nav-item">
                  <a
                    class="s-nav-link"
                    nz-tooltip
                    [nzTooltipTitle]="'تقديم شكاوى أو متابعة القضايا المتعلقة بخدمات النقل'"
                    nzTooltipPlacement="bottom"
                    [ngClass]="{
                      active:
                        currentSubSection ===
                        ROUTES.PRIVATE.DASHBOARD.MY_TRANSPORT_REPORTS
                    }"
                    (click)="
                      changeCurrentSubSection(
                        ROUTES.PRIVATE.DASHBOARD.MY_TRANSPORT_REPORTS
                      )
                    "
                    role="button"
                  >
                    <span class="nav-link-text">شكاوى النقل</span>
                    <i class="text-primary ni ni-support-16"></i>
                  </a>
                </li>
              </ul>
            </li>

            <li
              *ngIf="
                type === USER_TYPES.BUYER_SELLER ||
                type === USER_TYPES.BUYER ||
                type === USER_TYPES.SELLER
              "
              (click)="hideMenu()"
              class="nav-item"
            >
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'سجل المعاملات المالية، الإيداعات، السحوبات، والعمولات'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active:
                    currentSection === ROUTES.PRIVATE.DASHBOARD.TRANSACTIONS
                }"
                (click)="
                  changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.TRANSACTIONS)
                "
                role="button"
              >
                <span class="nav-link-text">معاملاتي المالية </span>
                <i class="text-primary ni ni-collection"></i>
              </a>
            </li>
            
            <li
              *ngIf="
                type === USER_TYPES.BUYER_SELLER || type === USER_TYPES.BUYER || type === USER_TYPES.SELLER
              "
              (click)="hideMenu()"
              class="nav-item"
            >
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'عرض وإدارة جميع حجوزاتك للخدمات والمنتجات'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active:
                    currentSection === ROUTES.PRIVATE.DASHBOARD.MY_RESERVATIONS
                }"
                (click)="
                  changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.MY_RESERVATIONS)
                "
              >
                <span class="nav-link-text">حجوزاتي</span>
                <i class="ni-calendar-grid-58 text-primary ni"></i>
              </a>
            </li>

            <li
              *ngIf="
                type === USER_TYPES.BUYER_SELLER || type === USER_TYPES.BUYER || type === USER_TYPES.SELLER
              "
              (click)="hideMenu()"
              class="nav-item"
            >
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'الإبلاغ عن مشاكل في الحجوزات أو المطالبة باسترداد الأموال'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active:
                    currentSection === ROUTES.PRIVATE.DASHBOARD.MY_RESERVATION_REPORTS
                }"
                (click)="
                  changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.MY_RESERVATION_REPORTS)
                "
              >
                <span class="nav-link-text">شكاوى الحجوزات</span>
                <i class="text-primary ni ni-notification-70"></i>
              </a>
            </li>

            <li
              *ngIf="
                type === USER_TYPES.BUYER_SELLER  || type === USER_TYPES.SELLER
              "
              (click)="hideMenu()"
              class="nav-item"
            >
              <a
                class="nav-link"
                nz-tooltip
                [nzTooltipTitle]="'إدارة منتجاتك المعروضة للبيع، الأسعار، والكميات المتاحة'"
                nzTooltipPlacement="bottom"
                [ngClass]="{
                  active:
                    currentSection === ROUTES.PRIVATE.DASHBOARD.MY_PRODUCTS
                }"
                (click)="
                  changeCurrentSection(ROUTES.PRIVATE.DASHBOARD.MY_PRODUCTS)
                "
              >
                <span class="nav-link-text">منتجاتي</span>
                <i class="text-primary ni ni-box-2"></i>
              </a>
            </li>

            <li class="nav-item">
              <br><br><br><br>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>